module.exports = __webpack_public_path__ + "static/media/tj.718e69c1.svg";